import {Component, Input} from '@angular/core';

@Component({
    selector: 'a-button-back',
    templateUrl: './a-button-back.component.html',
    styleUrls: ['./a-button-back.component.scss'],
    // tslint:disable-next-line:no-host-metadata-property
})
export class AButtonBackComponent {

    @Input()
    isHidden: boolean = false;

    @Input()
    public loading: false;

    @Input()
    public labelKey: string;

    @Input()
    public showBackIcon: boolean = true;

    @Input()
    public expanded: boolean = true;
}
